import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const Footer: React.FC = () => {
  const { t, language } = useLanguage();

  const companyInfo = {
    name: '뽀꼬톡(주)',
    address: '연수구 컨벤시아대로 81 드림시티 5층 509-제이475호 (송도동)',
    postalCode: '21995',
    country: '대한민국',
    website: 'https://pocotalk.app',
    contactPerson: '윤주봉',
    email: 'hello@pocotalk.app',
    phone: '+82-10-2171-0482'
  };

  return (
    <footer className="bg-gray-50 border-t border-gray-200 mt-20">
      <div className="container mx-auto px-4 py-8">
        {/* 회사 정보 섹션 */}
        <div className="mb-8">
          
          {/* 회사 정보 그리드 */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* 회사명 및 주소 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <span className="text-sm font-medium text-gray-800 min-w-[60px]">
                  {language === 'ko' ? '회사명' : 'Company'}
                </span>
                <span className="text-sm text-gray-600">
                  {companyInfo.name}
                </span>
              </div>
              <div className="flex items-start space-x-3">
                <span className="text-sm font-medium text-gray-800 min-w-[60px]">
                  {language === 'ko' ? '주소' : 'Address'}
                </span>
                <div className="text-xs text-gray-600 leading-relaxed">
                  <div>{companyInfo.address}</div>
                </div>
              </div>
            </div>

            {/* 담당자 정보 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <span className="text-sm font-medium text-gray-800 min-w-[60px]">
                  {language === 'ko' ? '대표' : 'CEO'}
                </span>
                <span className="text-sm text-gray-600">
                  {companyInfo.contactPerson}
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <span className="text-sm font-medium text-gray-800 min-w-[60px]">
                  {language === 'ko' ? '이메일' : 'Email'}
                </span>
                <a 
                  href={`mailto:${companyInfo.email}`}
                  className="text-sm text-mint hover:text-mint/80 transition-colors"
                >
                  {companyInfo.email}
                </a>
              </div>
            </div>

            {/* 연락처 정보 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <span className="text-sm font-medium text-gray-800 min-w-[60px]">
                  {language === 'ko' ? '전화번호' : 'Phone'}
                </span>
                <a 
                  href={`tel:${companyInfo.phone}`}
                  className="text-sm text-mint hover:text-mint/80 transition-colors"
                >
                  {companyInfo.phone}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          <div className="text-sm text-gray-500 text-center md:text-left">
            &copy; 2024 {companyInfo.name}. All rights reserved.
          </div>
          <div className="flex items-center space-x-4 text-sm">
            <Link to="/privacy" className="text-gray-500 hover:text-mint transition-colors">
              {t('nav.privacy')}
            </Link>
            <span className="text-gray-300">|</span>
            <Link to="/terms" className="text-gray-500 hover:text-mint transition-colors">
              {t('nav.terms')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
